import { AccountProfile } from '@core/swagger-client';

export const ProfileAbbreviation = ({ profile }: { profile: AccountProfile | null }) => {
    let abbreviation = '';
    if (profile) {
        if (profile.firstName) {
            abbreviation = profile.firstName.charAt(0);
        }
        if (profile.lastName) {
            abbreviation += profile.lastName.charAt(0);
        }
        if (!abbreviation && profile.nickname) {
            const parts = (profile.nickname ?? '').split(' ');
            for (let i = 0; i < Math.min(2, parts.length); i++) {
                abbreviation += parts[i].charAt(0);
            }
        }
    }

    return <>{abbreviation}</>;
};
